/* eslint id-length: [2, {"exceptions":["a","b"]}] */

import { sortArbitrary, buildRowProperties } from './util';
import { appDefault as constants } from '../../config/config';

export default function dateSort(a, b, column, isInverted) {
  const aVal = Date.parse(a);
  const bVal = Date.parse(b);
  const aNotAvailable = constants.dataNotAvailable.indexOf(a) !== -1;
  const bNotAvailable = constants.dataNotAvailable.indexOf(b) !== -1;
  const aInvalid = isNaN(aVal) || aNotAvailable;
  const bInvalid = isNaN(bVal) || bNotAvailable;
  const aProps = buildRowProperties(a, column, constants);
  const bProps = buildRowProperties(b, column, constants);

  // NAs pushed to the bottom
  if (aProps.naData && bProps.naData) {
    const sorted = sortArbitrary(
      aProps.value,
      bProps.value,
      constants.dataNotAvailable,
      isInverted
    );
    if (sorted) {
      return sorted;
    }
  } else if (aProps.naData) {
    return (isInverted ? -1 : 1);
  } else if (bProps.naData) {
    return (isInverted ? 1 : -1);
  }

  if (aInvalid && bInvalid) {
    return (isInverted ? 1 : -1) * a.localeCompare(b);
  } else if (aInvalid) {
    return (isInverted ? -1 : 1) * 1;
  } else if (bInvalid) {
    return (isInverted ? -1 : 1) * -1;
  }

  return isInverted ? aVal - bVal : bVal - aVal;
}



// WEBPACK FOOTER //
// ../datacenter/app/js/util/sorters/dateSort.js